import { v4 as uuidv4 } from 'uuid';

export function NotFound(props = {}, childrenComponents = []) {
	return {
		componentName: 'NotFound',
		componentId: uuidv4(),
		props,
		childrenComponents,
	};
}
